enum Feature {
  hivebriteAccess = "hivebriteAccess",
  upgradeButton = "upgradeButton",
  upgradeButtonModal = "upgradeButtonModal",
  accountManagement = "accountManagement",
  ukAccountManagementDashboard = "ukAccountManagementDashboard",
  landInsightAccess = "landInsightAccess",
  planningSearch = "planningSearch",
  planningSearchBulk = "planningSearchBulk",
  saveSiteBulk = "saveSiteBulk",
  planningAlerts = "planningAlerts",
  unlimitedPlanningClicks = "unlimitedPlanningClicks",
  propertySearch = "propertySearch",
  ownershipSearch = "ownershipSearch",
  unlimitedOwnershipClicks = "unlimitedOwnershipClicks",
  ultimateOwner = "ultimateOwner",
  premiumSiteCard = "premiumSiteCard",
  siteCardActivity = "siteCardActivity",
  ultimateSiteCard = "ultimateSiteCard",
  ownershipCSVExport = "ownershipCSVExport",
  ownershipLayer = "ownershipLayer",
  ownershipBundle = "ownershipBundle", //this is a license feature
  powerLayer = "powerLayer",
  planningLayer = "planningLayer",
  propertyInformationLayer = "propertyInformationLayer",
  pricepaidLayer = "pricepaidLayer",
  planningPolicyLayer = "planningPolicyLayer",
  comparablesCalculator = "comparablesCalculator",
  comparablesPpSqftMode = "comparablesPpSqftMode",
  documentPurchase = "documentPurchase",
  masterMap = "masterMap",
  siteReport = "siteReport",
  ownershipChangeAlerts = "ownershipChangeAlerts",
  drawings = "drawings",
  commercialSearch = "commercialSearch",
  nonChargeableOSMaps = "nonChargeableOSMaps",
  leaseholdDetails = "leaseholdDetails",
  usAccess = "usAccess",
  zoningLayer = "zoningLayer",
  rezoningApplications = "rezoningApplications",
  demographics = "demographics",
  buildingPermits = "buildingPermits",
  ukMapBoundaries = "ukMapBoundaries",
  usLocationSearch = "usLocationSearch",
  usComparablesAccess = "usComparablesAccess",
  ukLocationSearch = "ukLocationSearch",
  usOwnershipAccess = "usOwnershipAccess",
  unlimitedMasterMapClicks = "unlimitedMasterMapClicks",
  hazards = "hazardsLayer",
  comparablesHeatMapBeta = "comparablesHeatMapBeta",
  XDOG = "XDOG",
  zooplaFullAccess = "zooplaFullAccess",
  constraintsAdminLayer = "constraintsAdminLayer",
  disableDatadogRum = "disableDatadogRum",
  disableGeofence = "disableGeofence",
  disableUseDevicePixels = "disableUseDevicePixels",
  physicalSend = "physicalSend",
  landFundAccess = "landFundAccess",
  zooplaCompsCalculatorExport = "zooplaCompsCalculatorExport",
  sitesPipelineLoadAllStagesUpfront = "sitesPipelineLoadAllStagesUpfront",
  TURTLES = "TURTLES",
  sourcingToolPlanningApplicationsBeta = "sourcingToolPlanningApplicationsBeta",
  showLayers = "showLayers",
  siteDetailsEditSite = "siteDetailsEditSite",
  showSubNavigationBar = "showSubNavigationBar",
  compsCalcDownloadFilter = "compsCalcDownloadFilter",
  scheduledSearches = "scheduledSearches",
  enableNewUserDropdown = "enableNewUserDropdown",
  multiFilterSearch = "multiFilterSearch",
  ukAllLayersBundle = "ukAllLayersBundle",
  enableHMLRBusinessGateway = "enableHMLRBusinessGateway",
  integrationsDashboardBeta = "integrationsDashboardBeta",

  /** Utility Report */
  siteUtilityReportBeta = "siteUtilityReportBeta",

  /** Letter Sending */
  letterSending = "letterSending",
  bulkLetterSending = "bulkLetterSending",

  /** Planning ---  */
  planningFilters = "planningFilters",
  newPlanningSiteCard = "newPlanningSiteCard",
  sourcingToolCSVExport = "sourcingToolCSVExport",
}

export default Feature;
